import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { moreTenThousand } from '@src/utils/index';

type RevealProps = {
    content: {
        isFeed: boolean;
        peopleNum: number;
    };
};

const Reveal = ({ content }: RevealProps) => {
    const isFeed = content.isFeed || false;
    const peopleNum = moreTenThousand(content.peopleNum);

    return (
        <div className={isFeed ? styles.feedReveal : styles.articleReveal}>
            <div className={styles.revealBox}>已揭晓 {peopleNum}人觉得预测很准</div>
        </div>
    );
};

export default errorBoundary(Reveal);
